export default __webpack_public_path__ + "static/media/27_swiss_dj.6b30e349.png";